export function StateMessage({ title, actionLabel, onAction }: { title: string; actionLabel?: string; onAction?: () => void }) {
  return <section role="status" className="mx-auto grid min-h-48 max-w-lg place-content-center gap-4 px-4 text-center">
    <p className="font-bold text-slate-700">{title}</p>
    {onAction && <button type="button" onClick={onAction} className="min-h-11 rounded-xl bg-blue-600 px-5 font-bold text-white">{actionLabel ?? 'Thử lại'}</button>}
  </section>
}
